<template>
  <div class="kui-calendar">
    <kui-validatebox ref='validator' :options='options'>
      <div slot="content" :class='{"redBorder":!isPassValidate,"right-border":!options.longTime}' class="calendar-warp">
        <span v-show="options.title" class="kui-calendar-title">{{titleName}}</span>
        <el-date-picker v-model="value" placeholder="请选择日期" value-format="yyyyMMdd" @blur="validate(value)"
          @focus="hideTips" :disabled="disabled">
        </el-date-picker>
        <el-checkbox v-if='options.longTime' @change='setLongTime' border>
          长期
        </el-checkbox>
      </div>
    </kui-validatebox>
  </div>
</template>
<script>
export default {
  name: "kui-datebox",
  props: {
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function () {
    return {
      disabled: false,
      value: "",
      isPassValidate: true  //校验是否通过
    };
  },
  computed: {
    titleName () {
      return this.options.title ? this.options.title + ":" : "";
    },
  },
  methods: {
    datebox (opts, ...params) {
      if (_.isString(opts)) {
        if (params.length > 1) {
          this[opts].call(this, params[0], params[1]);
        } else {
          this[opts].call(this, params[0]);
        }
      } else {
        //传进来参数是对象 就和options合并 并赋值
        _.assign(this.options, opts);
        _.each(this.options, (v, k) => {
          if (!_.isFunction(v) && k == "val") {
            this.setValue(v);
          }
        });
      }
    },
    setLongTime (isLong) {
      if (isLong) {
        this.setValue("30001231");
      } else {
        this.setValue("");
      }
    },
    hideTips () {
      this.isPassValidate = true;
      this.$refs.validator.hideTips();
    },
    validate (v) {
      this.isPassValidate = this.$refs.validator.validate(this.value);
      return this.isPassValidate;
    },
    getValue: function () {
      return this.value;
    },
    setValue: function (value) {
      this.value = value;
    },
    setEnabled: function () {
      this.disabled = false;
    },
    setDisabled: function () {
      this.disabled = true;
    },
    getData: function () {
      return {
        [this.options.field]: this.value
      };
    }
  },
};
</script>
<style lang='less' scoped>
.kui-calendar {
  .calendar-warp {
    display: flex;
    align-items: center;
    &.right-border {
      border-radius: 4px;
    }
    &.redBorder {
      input {
        border-color: red;
      }
      .el-checkbox {
        border-color: red;
        border-left-color: #c0c4cc;
      }
    }
    .kui-calendar-title {
      margin-right: 8px;
    }
    .el-input__inner {
      border-radius: 4px 0 0 4px;
    }
    .el-checkbox {
      &.is-bordered {
        border-radius: 0 4px 4px 0;
        margin-left: -1px;
        &.is-checked {
          border-color: #dcdfe6;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/lib/ui/default/datebox/index.vue